// true si el chat es no esta en la lista 
export const isChatUnique = (list = [], chat) => { 
  const result = list.find(item => {
    return item.chat === chat.chat
  })
  return result === undefined
}